import { IonIcon, IonSpinner } from '@ionic/react';
import { checkmarkDoneOutline } from 'ionicons/icons';
import React from 'react';

export const ResolverLoadingState: React.FC = () => (
  <div className="dup-placeholder">
    <IonSpinner name="dots" />
    <p>Looking through your library for duplicates…</p>
  </div>
);

export const NoDuplicatesState: React.FC = () => (
  <div className="dup-placeholder">
    <IonIcon className="dup-placeholder-icon" icon={checkmarkDoneOutline} />
    <h2>No duplicates found</h2>
    <p>
      Nothing in your library looks like a duplicate right now. Import more
      music or rescan and this page will fill itself in.
    </p>
  </div>
);
